// extracted by mini-css-extract-plugin
export default {"container":"WSTodoList-module_container-EMac8","item":"WSTodoList-module_item-gFgo4","mark":"WSTodoList-module_mark-D4IK7","content":"WSTodoList-module_content-P8GP5"};